import { gql } from '@apollo/client';
import type { SerializedHardwarePackage } from '@enmon/commons/lib/tools';

export const GET_HARDWARE_PACKAGES_DATA = gql`
  query hardwarePackagesData($sort: [String], $page: Int, $pageSize: Int) {
    hardwarePackages(pagination: { page: $page, pageSize: $pageSize }, sort: $sort) {
      data {
        id
        attributes {
          hardwares {
            data {
              id
              attributes {
                name
              }
            }
          }
          name
          priority
          query
        }
      }

      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export interface HardwarePackagesVariables {
  page: number;
  sort: string;
  pageSize: number;
}

export interface HardwarePackagesData {
  hardwarePackages: {
    data: Pick<SerializedHardwarePackage, 'id' | 'name' | 'priority' | 'query' | 'hardwares'>[];
    meta: { pagination: { total: number } };
  };
}
